import { exists } from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface BibliographySearchHistory {
  id: number
  type: string
  displayMethod: string
  searchTarget: string
  numberOfLimit: number
  searchMethodAnd: boolean
  searchMethodSynonym: boolean
  searchMethodAllograph: boolean
  title1: string
  title2: string
  titleInformation: boolean
  author1: string
  author1No: string
  author2: string
  author2No: string
  authorInformation: boolean
  subject1: string
  subject1No: string
  subject2: string
  subject2No: string
  series: string
  seriesNo: string
  completeWorks: string
  completeWorksNo: string
  notes: string
  contentTitle: string
  contentAuthor: string
  contentAuthorNo: string
  publisher: string
  publisherNo: string
  volumeLabel: string
  classNo: string
  publishedYearFrom: string
  publishedYearTo: string
  playbackTimeFrom: number
  playbackTimeTo: number
  volume: string
  volumeNumber: string
  volumeTotal: string
  dateLabel: string
  genre: string
  targetUsers: string
  targetUsersAv: string
  collectionType: string
  shelfType: string
  mark: string
  ndc: string
  book: string
  sub: string
  traderCode: string
  donorCode: string
  collectionStatus: string
  collectionStatusRemove: boolean
  holdingBranchCode: string
  orderStatus: string
  orderBranchCode: string
  acceptDateFrom: string
  acceptDateTo: string
  handlingType: string
  lendTotal: number
  lendTotalFlag: string
  lastLendDate: string
  lastLendDateFlag: string
  searchType: string
  collectionTarget: string
  materialFormat: string
  bibliographyClass: string
  newPublicationInformationDate: string
  newPublicationInformationVolume: string
  collectionNo: string
  exceptCheckDigit: boolean
  orderId: string
  bibliographyId: string
  isbn: string
  productNo: string
  magazineCode: string
  marcNo: string
  freeWords: string
  revision: number
}

export function BibliographySearchHistoryFromJSON(
  json: any
): BibliographySearchHistory {
  return {
    id: json.id,
    type: exists(json, 'type') ? json.type : '',
    displayMethod: exists(json, 'display_method') ? json.display_method : '',
    searchTarget: exists(json, 'search_target') ? json.search_target : '',
    numberOfLimit: exists(json, 'number_of_limit') ? json.number_of_limit : 0,
    searchMethodAnd: exists(json, 'search_method_and')
      ? json.search_method_and
      : false,
    searchMethodSynonym: exists(json, 'search_method_synonym')
      ? json.search_method_synonym
      : false,
    searchMethodAllograph: exists(json, 'search_method_allograph')
      ? json.search_method_allograph
      : false,
    title1: exists(json, 'title1') ? json.title1 : '',
    title2: exists(json, 'title2') ? json.title2 : '',
    titleInformation: exists(json, 'title_information')
      ? json.title_information
      : false,
    author1: exists(json, 'author1') ? json.author1 : '',
    author1No: exists(json, 'author1_no') ? json.author1_no : '',
    author2: exists(json, 'author2') ? json.author2 : '',
    author2No: exists(json, 'author2_no') ? json.author2_no : '',
    authorInformation: exists(json, 'author_information')
      ? json.author_information
      : false,
    subject1: exists(json, 'subject1') ? json.subject1 : '',
    subject1No: exists(json, 'subject1_no') ? json.subject1_no : '',
    subject2: exists(json, 'subject2') ? json.subject2 : '',
    subject2No: exists(json, 'subject2_no') ? json.subject2_no : '',
    series: exists(json, 'series') ? json.series : '',
    seriesNo: exists(json, 'series_no') ? json.series_no : '',
    completeWorks: exists(json, 'complete_works') ? json.complete_works : '',
    completeWorksNo: exists(json, 'complete_works_no')
      ? json.complete_works_no
      : '',
    notes: exists(json, 'notes') ? json.notes : '',
    contentTitle: exists(json, 'content_title') ? json.content_title : '',
    contentAuthor: exists(json, 'content_author') ? json.content_author : '',
    contentAuthorNo: exists(json, 'content_author_no')
      ? json.content_author_no
      : '',
    publisher: exists(json, 'publisher') ? json.publisher : '',
    publisherNo: exists(json, 'publisher_no') ? json.publisher_no : '',
    volumeLabel: exists(json, 'volume_label') ? json.volume_label : '',
    classNo: exists(json, 'class_no') ? json.class_no : '',
    publishedYearFrom: exists(json, 'published_year_from')
      ? json.published_year_from
      : '',
    publishedYearTo: exists(json, 'published_year_to')
      ? json.published_year_to
      : '',
    playbackTimeFrom: exists(json, 'playback_time_from')
      ? json.playback_time_from
      : 0,
    playbackTimeTo: exists(json, 'playback_time_to')
      ? json.playback_time_to
      : 0,
    volume: exists(json, 'volume') ? json.volume : '',
    volumeNumber: exists(json, 'volume_number') ? json.volume_number : '',
    volumeTotal: exists(json, 'volume_total') ? json.volume_total : '',
    dateLabel: exists(json, 'date_label') ? json.date_label : '',
    genre: exists(json, 'genre') ? json.genre : '',
    targetUsers: exists(json, 'target_users') ? json.target_users : '',
    targetUsersAv: exists(json, 'target_users_av') ? json.target_users_av : '',
    collectionType: exists(json, 'collection_type') ? json.collection_type : '',
    shelfType: exists(json, 'shelf_type') ? json.shelf_type : '',
    mark: exists(json, 'mark') ? json.mark : '',
    ndc: exists(json, 'ndc') ? json.ndc : '',
    book: exists(json, 'book') ? json.book : '',
    sub: exists(json, 'sub') ? json.sub : '',
    traderCode: exists(json, 'trader_code') ? json.trader_code : '',
    donorCode: exists(json, 'donor_code') ? json.donor_code : '',
    collectionStatus: exists(json, 'collection_status')
      ? json.collection_status
      : '',
    collectionStatusRemove: exists(json, 'collection_status_remove')
      ? json.collection_status_remove
      : false,
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? json.holding_branch_code
      : '',
    orderStatus: exists(json, 'order_status') ? json.order_status : '',
    orderBranchCode: exists(json, 'order_branch_code')
      ? json.order_branch_code
      : '',
    acceptDateFrom: exists(json, 'accept_date_from')
      ? dateToPlainFormat(json.accept_date_from)
      : '',
    acceptDateTo: exists(json, 'accept_date_to')
      ? dateToPlainFormat(json.accept_date_to)
      : '',
    handlingType: exists(json, 'handling_type') ? json.handling_type : '',
    lendTotal: exists(json, 'lend_total') ? json.lend_total : 0,
    lendTotalFlag: exists(json, 'lend_total_flag') ? json.lend_total_flag : '',
    lastLendDate: exists(json, 'last_lend_date')
      ? dateToPlainFormat(json.last_lend_date)
      : '',
    lastLendDateFlag: exists(json, 'last_lend_date_flag')
      ? json.last_lend_date_flag
      : '',
    searchType: exists(json, 'search_type') ? json.search_type : '',
    collectionTarget: exists(json, 'collection_target')
      ? json.collection_target
      : '',
    materialFormat: exists(json, 'material_format') ? json.material_format : '',
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : '',
    newPublicationInformationDate: exists(
      json,
      'new_publication_information_date'
    )
      ? json.new_publication_information_date
      : '',
    newPublicationInformationVolume: exists(
      json,
      'new_publication_information_volume'
    )
      ? json.new_publication_information_volume
      : '',
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    exceptCheckDigit: exists(json, 'except_check_digit')
      ? json.except_check_digit
      : false,
    orderId: exists(json, 'order_id') ? json.order_id : '',
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : '',
    isbn: exists(json, 'isbn') ? json.isbn : '',
    productNo: exists(json, 'product_no') ? json.product_no : '',
    magazineCode: exists(json, 'magazine_code') ? json.magazine_code : '',
    marcNo: exists(json, 'marc_no') ? json.marc_no : '',
    freeWords: exists(json, 'free_words') ? json.free_words : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
